import { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import { Facebook } from "lucide-react";

const FB_URL = "https://www.facebook.com/profile.php?id=61579996282258";

export default function StickyDonate() {
  const [visible, setVisible] = useState(false);
  const [nearFooter, setNearFooter] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
      const footer = document.querySelector('[data-testid="footer-section"]');
      if (footer) {
        const footerTop = footer.getBoundingClientRect().top;
        setNearFooter(footerTop < window.innerHeight + 20);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className={`fixed right-6 z-50 flex flex-col gap-3 transition-all duration-500 ${nearFooter ? "bottom-28" : "bottom-6"}`}
      style={{ animation: "float-in 0.6s ease-out" }}>
      <a
        data-testid="sticky-facebook-button"
        href={FB_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 rounded-full bg-[#1877F2] shadow-lg shadow-[#1877F2]/30 flex items-center justify-center no-underline hover:-translate-y-1 transition-transform duration-300"
        aria-label="Follow us on Facebook"
      >
        <Facebook className="w-5 h-5 text-white" />
      </a>
      <a
        data-testid="sticky-donate-button"
        href="https://20d0a0a2-9bc3-4878-a451-dbaa4c9318b7.paylinks.godaddy.com/bfd32eeb-318a-425f-b9fb-26a"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-pill btn-primary shadow-lg shadow-[#0E8DB5]/40 no-underline text-sm px-6 py-3 pulse-glow"
      >
        <Heart className="w-4 h-4" />
        Donate
      </a>
    </div>
  );
}
